import React from "react";
import {
  makeStyles,
  Container,
  Modal,
  Grid,
  Typography,
} from "@material-ui/core";
import { ButtonPrimary } from '../components-atoms';
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";
export const CollectOrderCanceledModal = (props: any) => {
  const classes = useStyles();

  return (
    <Modal
      open={props.isOpen}
      onClose={props.onClose}
      className={classes.modal}
    >
      <Container className={classes.modalContainer}>
        <Grid container spacing={1}></Grid>
        <Grid item className={classes.titleSection}>
          <Typography variant="h6" component="h6" color="textPrimary">
            Canceled order
          </Typography>
        </Grid>
        <Grid item className={classes.bodySection}>
          <Grid item container direction="row">
            <Typography variant="body2" component="p" color="textPrimary">
              The order <strong>{props.referenceNumber}</strong> you are currently viewing has been canceled by the user.
            </Typography>
          </Grid>
        </Grid>
        <Grid item container xs={12} justifyContent="flex-end">
          <ButtonPrimary
            onClick={props.onClose}
            className={classes.okButton}>
            OK
          </ButtonPrimary>
        </Grid>
      </Container>
    </Modal>
  );
};
const useStyles = makeStyles({
  modal: { alignItems: "center", justifyContent: "center" },
  modalContainer: {
    backgroundColor: "white",
    maxWidth: "480px",
    boxShadow:
      "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
    borderRadius: "20px",
    padding: "24px",
    margin: "0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  titleSection: {
    marginBottom: "8px",
  },
  bodySection: {
    marginTop: "16px",
    marginBottom: "36px",
  },
  okButton: {
    borderRadius: "8px",
    padding: "6px 16px",
    ...buttonHoverAndActive
  },
  mt8: {
    marginTop: 8,
  },
});
